import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
import { Button } from "iuvity-ui-components";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { FileUpload } from 'primereact/fileupload';
import {
  DialogProps,
  CustomDialog,
} from "../../components/dialog/CustomDialog";
import { Column } from "iuvity-ui-components/dist/column";
import { DataTable } from "iuvity-ui-components/dist/datatable";
import { TableHeader } from "../../components/datatable/TableHeader";
import { Card } from "iuvity-ui-components/dist/card";
import { Tag } from "iuvity-ui-components/dist/tag";
import { MultiSelect } from "primereact/multiselect";
import { IMPORT_KEYS_VALIDATION } from "../../constants/index";
import { useEnvironments } from "../../hooks/useEnvironments";
import {
  importDataStructureConverter,
  downloadInfo,
  configsFilterToImport,
} from "../../utils/index";
import { AppContext } from "../../context";
import { formatDateToLocale } from "../../helpers/formatDate";
import { registerAudit } from "../../helpers/registerAudit";

export const RenderTable: React.FC<any> = ({
  t,
  columns,
  data,
  selectedColumns,
  setSelectedColumns,
  filters,
  setFilters,
  language,
  onClearFiltersColumn,
  setFuncTranslationsObj,
}: any) => {

  const [disableClearFilterButton, setDisableClearFilterButton] = useState<{
    functionality: boolean;
    version: boolean;
  }>({
    functionality: false,
    version: false,
  });

  const [disableApplyFilterButton, setDisableApplyFilterButton] = useState<{
    functionality: boolean;
    version: boolean;
  }>({
    functionality: false,
    version: false,
  });

  const [valuesOfColumnFilterFields, setValuesOfColumnFilterFields] = useState<{
    functionality: string;
    version: string;
  }>({
    functionality: '',
    version: '',
  });

  const [functTranslationsAux, setFunctTranslationsAux] = useState<{}>({});
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  
  useEffect(()=>{
    setFuncTranslationsObj(functTranslationsAux);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[functTranslationsAux]);

  const onClearFiltersPerTable = ( options: any, filtersFromSession: any ) => {
    setFilters({
      global: { value: options?.field === 'global' ? null : filtersFromSession?.global?.value, matchMode: FilterMatchMode.CONTAINS },
      functionality: { value: options?.field === 'functionality' ? null : filtersFromSession?.functionality?.value, matchMode: FilterMatchMode.IN },
      version: { value: options?.field === 'version' ? null : filtersFromSession?.version?.value, matchMode: FilterMatchMode.IN },
    });

    // luego de dar click en limpiar, elimina los criterios de búsqueda.
    setDisableClearFilterButton((prev:any)=>({
      ...prev,
      [options?.field]: true,
    }));
    setValuesOfColumnFilterFields((prev)=>({
      ...prev,
      [options.field]: '',
    }));
    setDisableApplyFilterButton((prev)=>({
      ...prev,
      [options?.field]: false
    }));
  };

  const ItemsTemplate = (option: any) => {
    return (
      <div className="p-multiselect-representative-option">
        <span className="image-text">{option?.label}</span>
      </div>
    );
  };
  
  const multiselectFilterTemplate = (options: any, arrayWithoutDuplicates: any) => {
    return (<>
      <label htmlFor={options.field} className="block lb mt-2 mb-1">
        {t(`Translations.${options.field}Label`)}
      </label>
      <MultiSelect
        // @ts-ignore
        value={valuesOfColumnFilterFields[options.field]}
        display="chip"
        options={arrayWithoutDuplicates}
        itemTemplate={ItemsTemplate}
        placeholder={t(`Translations.${options.field}PlaceholderLabel`)} 
        className="mb-2"
        emptyFilterMessage={t("Translations.noAvailableMessage")}
        filter
        onChange={(e)=>{
          const products = t(`Environments.productsLabel`);
          const transfers = t(`Environments.transfersLabel`);
          const mappedfields = t(`Environments.mappedfieldsLabel`);
          const productproperties = t(`Environments.productpropertiesLabel`);
          const transactionproperties = t(`Environments.transactionpropertiesLabel`);

          const valuesToUpdate = [...e.value];

          if (
            valuesToUpdate.some(
              (item: string) =>
                [products, transfers].includes(item) &&
                !e.value.includes(mappedfields)
            )
          ) {
            valuesToUpdate.push(mappedfields);
          }

          if (
            valuesToUpdate.includes(products) &&
            !valuesToUpdate.includes(productproperties)
          ) {
            valuesToUpdate.push(productproperties);
          }

          if (
            valuesToUpdate.includes(transfers) &&
            !valuesToUpdate.includes(transactionproperties)
          ) {
            valuesToUpdate.push(transactionproperties);
          }

          valuesToUpdate.map((value) => {
            setValuesOfColumnFilterFields((prev)=>({
              ...prev,
              [options.field]: valuesToUpdate,
            }));
            options.filterCallback(valuesToUpdate);
            setDisableApplyFilterButton((prev)=>({
              ...prev,
              [options.field]: valuesToUpdate?.length > 0
            }));
          })

        }}
        />
    </>)
  };

  const filterTemplate = (options: any) => {
    let functTranslationsAuxObj = {};
    const arrayOriginal = data
      ?.map((label: any) =>
        ['functionality'].includes(options.field)
          ? (()=>{
            functTranslationsAuxObj = {
              ...functTranslationsAuxObj,
              [t(`Environments.${label?.functionality.toLowerCase()}Label`)]: label?.functionality
            }
              return {
                value: t(`Environments.${label?.functionality.toLowerCase()}Label`),
                label: t(`Environments.${label?.functionality.toLowerCase()}Label`),
              }
            })()
          : ({
            label: label[`${options.field}`],
            value: label[`${options.field}`]
          }))
      ?.filter((item: { label: string, value: string }) => item.label)
      ?.sort((a: any, b: any) => a.label.localeCompare(b.label));
    
    const arrayWithoutDuplicates = arrayOriginal?.filter((object: any, currentIndex: any) => {
      return arrayOriginal.findIndex((duplicateObject: any) =>
        duplicateObject.label === object.label) === currentIndex;
    });

    if (options.field === 'functionality'
      && (JSON.stringify(functTranslationsAux) !== JSON.stringify(functTranslationsAuxObj))) setFunctTranslationsAux(functTranslationsAuxObj);

    return multiselectFilterTemplate(options, arrayWithoutDuplicates)
  };
  
  const filterClearTemplate = (options: any) => {
    const filtersFromSession = JSON.parse(sessionStorage?.getItem('import-config-filters-table') ?? '{}')?.filters;

    return (
      <Button
        label={t("Tenants.clearFilterLabel")}
        variant="p-button-text"
        disabled={(filtersFromSession?.hasOwnProperty('global')
            ? !filtersFromSession[options?.field]?.value : true)
            // @ts-ignore
            || disableClearFilterButton[options?.field]}
        onClick={() => onClearFiltersPerTable(options, filtersFromSession)}
      />
    )
  }

  const filterApplyTemplate = (options: any) => {
    return (
      <Button
        label={t("Tenants.applyFilterLabel")}
        className="p-button"
        // @ts-ignore
        disabled={!disableApplyFilterButton[options.field]}
        onClick={() => {
          options.filterApplyCallback();
          setDisableClearFilterButton((prev:any)=>({
            ...prev,
            [options?.field]: false,
          }));
        }}
      />
    )
  };

  const statusBodyTemplate = (rowData: any) => (
    <Tag
      value={t(`Translations.${rowData.status}StatusLabel`)}
      severity={
        (['VALID'].includes(rowData.status) && 'success') ||
        (['INVALID'].includes(rowData.status) && 'danger') ||
        'warning'
      }
    />
  );

  useEffect(() => {
    if (sessionStorage.getItem('import-config-filters-table')) {
      const dataSession = JSON.parse(sessionStorage.getItem('import-config-filters-table') || "");
      const global = dataSession.filters.global;
      setGlobalFilterValue(global);
    }
  }, [filters]);

  return (
    <DataTable
      className="dt-c mt-4"
      header={
        <TableHeader
          title={t("Environments.configurationsTableTitle")}
          columns={columns}
          selectedColumns={selectedColumns}
          toggleColumns={setSelectedColumns}
          filters={filters}
          setFilters={setFilters}
          reload={() => {}}
          onClearFiltersColumn={() => {
            onClearFiltersColumn();
            setValuesOfColumnFilterFields({
              functionality: '',
              version: '',
            });
          }}
          globalFilterValue={globalFilterValue}
        />
      }
      currentPageReportTemplate={t(
        "ConsoleTranslations.rowsPaginatorTemplateLabel"
      )}
      paginatorRight={t('ConsoleTranslations.itemsTextDatatableLabel')}
      emptyMessage={t("TableActions.emptyMessage")}
      rows={10}
      size="normal"
      editMode="row"
      dataKey="id"
      sortField="status"
      sortMode="single"
      sortOrder={1}
      filters={filters}
      value={data.map((item: any) => ({
        ...item,
        functionality: t(`Environments.${item?.functionality}Label`),
        type: t(`Environments.${item?.type}Label`),
        createdat: formatDateToLocale(item.createdat, language, true),
        updatedat: formatDateToLocale(item.updatedat, language, true),
      }))}
      globalFilterFields={["functionality", "version"]}
      filterDisplay="menu"
      stateKey="import-config-filters-table"
    >
      {selectedColumns.map((col: any) => (
        <Column
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={true}
          align="left"
          body={(rowData) => col.field === 'status' ? statusBodyTemplate(rowData) : rowData[col.field]}
          filter={['functionality', 'version'].includes(col.field)}
          filterApply={filterApplyTemplate}
          filterClear={filterClearTemplate}
          filterElement={filterTemplate}
          showFilterMenu
          showApplyButton
          showClearButton
        />
      ))}
    </DataTable>
  );
};

export const EnvImportPage = () => {
  const {
    t,
    appState: { language, selectedEnvironment, user, tenantParentName },
  } = useContext(AppContext);

  const navigate = useNavigate();

  const { envAction } = useEnvironments("ACTIONS");
  // const { exportImportGeoAction } = useExportImportGeo("ACTIONS");

  const [filePath, setFilePath] = useState<string>("");
  const [successData, setSuccessData] = useState<{}>({});
  const [errorData, setErrorData] = useState<any[]>([]);
  const [successDataToShow, setSuccessDataToShow] = useState<any[]>([]);
  const [errorDataToShow, setErrorDataToShow] = useState<any[]>([]);
  const [uploadErrorMsg, setuploadErrorMsg] = useState<boolean>(false);
  const [dataGeoToImport, setDataGeoToImport] = useState();
  const [disableUploadFile, setDisableUploadFile] = useState<boolean>(false);
  const [showResultFileValidation, setShowResultFileValidation] = useState<boolean>(false);

  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [hasErrors, setHasErrors] = useState<boolean>(false);
  const [funcTranslationsObj, setFuncTranslationsObj] = useState<any>({});

  const defaultFilterValues = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    functionality: { value: null, matchMode: FilterMatchMode.IN },
    version: { value: null, matchMode: FilterMatchMode.IN },
  };
  const [filters, setFilters] = useState(defaultFilterValues);

  const onClearFiltersColumn = () => {
    setFilters(defaultFilterValues);
  };

  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const columns = useMemo(() => {
    return [
      {
        field: "status",
        header: t("Environments.statusLabel"),
      },
      {
        field: "id",
        header: "ID",
      },
      {
        field: "functionality",
        header: t("Translations.functionalityLabel"),
      },
      {
        field: "type",
        header: t("Environments.typeLabel"),
      },
      {
        field: "name",
        header: t("Environments.nameLabel"),
      },
      {
        field: "version",
        header: t("Environments.versionLabel"),
      },
      {
        field: "createdat",
        header: t("Translations.createdatLabel"),
      },
      {
        field: "updatedat",
        header: t("Translations.updatedatLabel"),
      },
    ];
  }, [t]);

  const errorColumns = useMemo(() => {
    const partialColumns = columns?.filter((column)=> column?.field !== 'status');
    return [
      {
        field: "status",
        header: t("Environments.statusLabel"),
      },
      {
        field: "validations",
        header: t("Translations.validationsLabel"),
      },
      ...partialColumns,
    ];
  }, [t, columns]);

  const [selectedColumns, setSelectedColumns] = useState(columns);
  const [selectedErrorColumns, setSelectedErrorColumns] =
    useState(errorColumns);

  const onReturn = () => navigate("/applications/edit");

  const handleModalProps = (actionType: "action" | "cancel" | "errorexport" | "import") => {
    switch (actionType) {
      case "action":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t(`Translations.saveModalTitle`),
          content: t(`Translations.saveModalContent`),
          // onConfirm: onAction,
          onConfirm: ()=>{}
        }));
      case "cancel":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Translations.cancelModalTitle"),
          content: t("Translations.cancelModalContent"),
          onConfirm: onReturn,
        }));
      case "errorexport":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Environments.errorExportModalTitle"),
          content: t("Environments.errorExportModalContent"),
          onConfirm: onDownloadErrors,
        }));
      case "import":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t(`Environments.importModalTitle`),
          content: t(`Environments.importModalContent`),
          onConfirm: onImport,
        }));
      default:
        return;
    }
  };

  const onImport = async () => {
    try {
      const allValuesFilter = JSON.parse(sessionStorage?.getItem('import-config-filters-table') ?? '{}')?.filters;
      const version = allValuesFilter?.version?.value ?? [];
      const functionality = allValuesFilter?.functionality?.value
        ?.map((elem:string)=> funcTranslationsObj.hasOwnProperty(elem) ? funcTranslationsObj[elem] : undefined)
        ?.filter((elem:any)=> !!elem) ?? [];
      const selectedVersions: string[] =
        version.length > 0
          ? version
          : formOptions?.version.map((item) => item?.value) || [];
      const itemsToImport = configsFilterToImport(successData, {
        functionality,
        version,
      });
      const actionStatus = await envAction("IMPORT", {
        filename: filePath,
        numImportItems: filteredData?.length || 0,
        appData: {
          appid: selectedEnvironment?.applicationid,
          envid: selectedEnvironment?.id,
          version: selectedVersions,
          updatedby: user?.name,
        },
        itemsToImport,
      });
      // await exportImportGeoAction("IMPORTGEO", dataGeoToImport);

      if (actionStatus === "SUCCESS") {
        onReturn();
      }

    } catch (error) {}
  };

  const onDownloadErrors = () => {
    downloadInfo(
      `${t("Environments.errorsFilenameTitle")}_${
        selectedEnvironment?.fullname
      }_${t("Environments.filenameExtraInfo")}${
        new Date().toISOString().substring(0, 10).replace(/-|:/g, "") +
        "-" +
        new Date().toLocaleTimeString("es-ES").replace(/-|:/g, "")
      }`,
    //   Object.fromEntries(
    //     Object.entries(errorData).filter(
    //       ([_, value]) => (value as any).length > 0
    //     )
    //   )
    errorData ?? []
  );

  registerAudit({
    role: "",
    group: "",
    tenant: tenantParentName,
    environment: "",
    segment: "",
    functionality: "ADMIN_APLICATIONS",
    activity: "ERRORS_DOWNLOAD_CONFIGURATIONS",
    object: "APPLICATION_ENVIRONMENT",
    initialValue: null,
    finalValue: `${errorData.length}`,
    status: "SUCCESS",
    errorCode: "",
    errorDescription: "",
    errorCause: "",
  });

  };

  const invoiceUploadHandler = ({ files }: any) => {
    const [file] = files;
    const fileReader = new FileReader();
    fileReader.readAsText(file, "UTF-8");
    fileReader.onload = (e) => {
      setFilePath(file.name);
      try {
        const newData = JSON.parse(`${e.target?.result}`);
        setDataGeoToImport(newData?.dataGeo)
        delete newData?.dataGeo;
        const keysToValidate = Object.keys(IMPORT_KEYS_VALIDATION);
        if (Object.keys(newData).every((key) => keysToValidate.includes(key))) {
          const { successData, errorData, successDataToShow, errorDataToShow } =
            importDataStructureConverter(t, newData);
          setSuccessData(successData);
          setSuccessDataToShow([...errorDataToShow, ...successDataToShow]);
          setErrorData([...errorDataToShow]);
          setErrorDataToShow(errorDataToShow);
          setHasErrors(errorDataToShow?.length > 0);
        } else {
          setuploadErrorMsg(true);
        }
      } catch (e) {
        console.log(e);
        setuploadErrorMsg(true);
      }
    };
  };

  const invoiceRemoveHandler = () => {
    setSuccessData({});
    setErrorData([]);
    setSuccessDataToShow([]);
    setErrorDataToShow([]);
    setFilteredData([]);
    setFilePath("");
    setuploadErrorMsg(false);
  };

  const formOptions = useMemo(() => {
    if (successDataToShow) {
      return {
        functionality: [
          ...new Set(successDataToShow.map((item: any) => item.functionality)),
        ]
          .map((item) => ({
            value: item,
            label: t(`Environments.${item}Label`),
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
        version: [
          ...new Set(successDataToShow.map((item: any) => item.version)),
        ].map((item) => ({
          value: `${item}`,
          label: `${item}`,
        })),
      };
    } else {
      return;
    }
  }, [t, successDataToShow]);

  useEffect(() => {
    if (successDataToShow) setFilteredData(successDataToShow);
  }, [successDataToShow]);

  useEffect(() => {
    if (language)
      setSelectedColumns((prev) =>
        prev.map((col) => ({
          field: col.field,
          header: ['functionality', 'validations', 'createdat', 'updatedat'].includes(col.field)
            ? t(`Translations.${col.field}Label`)
            : (col.field === 'id'
                ? 'ID'
                : t(`Environments.${col.field}Label`)),
        }))
      );
  }, [t, language, setSelectedColumns]);

  return (
    <>
      <TransactionalSubheader
        subheaderTitle={
          <div style={{ position: "relative", left: "-40px" }}>
            <i
              className="iu iu-icon-left pr-3"
              onClick={onReturn}
              aria-hidden="true"
              style={{
                fontSize: "var(--font-size-tablet-title)",
                cursor: "pointer",
              }}
            />
            {t("Applications.importApplicationTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("Applications.applicationsBreadcrumbLabel")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: t("Applications.applicationsBreadcrumbLabel"),
              style: { fontWeight: "bold" },
              disabled: true
            },
            {
              label: t("Applications.applicationAdminTitle"),
              command: () => navigate("/applications"),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
            },
            {
              label: t("Applications.editApplicationTitle"),
              command: () => navigate("/applications/edit"),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
            },
            {
              label: t("Applications.importApplicationTitle"),
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
          <div className="t-subheader-content">
            <span
              dangerouslySetInnerHTML={{ __html: t("Applications.importApplicationDescription")}}
              className="block mt-2 w-full"
              style={{
                lineHeight: '1.5'
              }}
            />
          </div>
      </TransactionalSubheader>

      <BoxFull className="my-5 py-0 px-0" variant="tertiary">
        <div
          className={`upload-container w-full`}
        >
          <div
            className="card"
            style={{
              width: '100%',
            }}
          >
            <FileUpload
              accept=".json"
              // maxFileSize={1000000}
              cancelOptions={{
                style: {
                  display: 'none',
                }
              }}
              uploadOptions={{
                style: {
                  display: 'none',
                }
              }}
              chooseLabel={t("Translations.uploadFileComponentTitle")}
              chooseOptions={{
                icon: 'iu iu-icon-upload',
                className: disableUploadFile ? ' p-disabled p-button-link' : 'p-button-link',
              }}
              onSelect={(e)=>{ 
                invoiceUploadHandler(e)
                setDisableUploadFile(true);
              }}
              onRemove={()=>{
                sessionStorage.removeItem('import-config-filters-table');
                setDisableUploadFile(false);
                invoiceRemoveHandler();
                setShowResultFileValidation(false);
              }}
            />
          </div>
        </div>
        {uploadErrorMsg && (
          <span className="p-error block mt-5">
            {t("Applications.uploadFileErrorMsgLabel")}
          </span>
        )}

        {showResultFileValidation && filteredData.length > 0 && (
          <>
            <div className="flex justify-content-left w-full mt-5">
              <p
                className="boxTitle"
                style={{width: '100%'}}
              >
                {t("Environments.configurationsToImportTitle")}
              </p>
            </div>
            <span
              dangerouslySetInnerHTML={
                { __html: 
                  hasErrors
                    ? t("Environments.configurationsToImportErrorDescription")
                    : t("Environments.configurationsToImportDescription")
                }}
              className="block mt-2 mb-4 w-full"
            />
            <Card
              style={{
                width: '100%',
              }}
            >
              {
                
                <RenderTable
                  t={t}
                  columns={(()=>{
                    const columnsToShow = columns?.filter((column)=>column?.field !== 'status');
                    return hasErrors
                      ? [{
                          field: "status",
                          header: t("Environments.statusLabel"),
                        }, {
                          field: "validations",
                          header: t("Translations.validationsLabel"),
                        }, ...columnsToShow]
                      : [{
                        field: "status",
                        header: t("Environments.statusLabel"),
                      }, ...columnsToShow]
                  })()}
                  data={filteredData}
                  filters={filters}
                  setFilters={setFilters}
                  selectedColumns={hasErrors ? selectedErrorColumns : selectedColumns}
                  setSelectedColumns={hasErrors ? setSelectedErrorColumns : setSelectedColumns}
                  language={language}
                  onClearFiltersColumn={onClearFiltersColumn}
                  setFuncTranslationsObj={setFuncTranslationsObj}
                />
              }
            </Card>
          </>
        )}

        <div className="form-btngroup-footer justify-content-end my-5 p-0 gap-6">
          <Button
            variant="p-button-link"
            label={t(`Translations.cancelBtnLabel`)}
            onClick={onReturn}
          />
          {
            showResultFileValidation &&
            <Button
              variant="p-button-text"
              label={t(`Translations.errorsExportBtnLabel`)}
              onClick={() => handleModalProps("errorexport")}
              disabled={!hasErrors}
            />
          }
          <Button
            variant="p-button"
            label={showResultFileValidation ? t("Applications.importBtnLabel") : t("Translations.uploadBtnLabel")}
            disabled={!disableUploadFile || (showResultFileValidation && hasErrors) || uploadErrorMsg}
            onClick={() => {
              !showResultFileValidation
                ? setShowResultFileValidation(true)
                : handleModalProps("import");
            }}
          />
        </div>
      </BoxFull>

      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
